<template>
    <div class="list-item">
        <header @click="change">
            <div>
                <img src="../../../../assets/key/key-name-img.png" alt="">
                <strong>{{dataInfo.orgName}}</strong>
            </div>
            <img :src="getImg" alt="">
        </header>

        <main v-if="isShowInfo">

            <key-item v-for="data in getInfo"
                      :key="data.bindID"
                      :data-info="data">
            </key-item>

        </main>
    </div>
</template>

<script>
    import KeyItem from "./KeyItem";

    export default {
        name: "ListItem",

        props: {
            firstOrgId: String,
            dataInfo: {}
        },

        created() {
            if (this.firstOrgId === this.dataInfo.orgID) {
                this.isShowInfo = true;
            }
        },

        data() {
            return {
                isShowInfo: false
            }
        },

        methods: {
            change() {
                this.isShowInfo = !this.isShowInfo;
            }
        },

        computed: {
            getImg() {
                if (this.isShowInfo) {
                    return require("../../../../assets/key/down.png");
                }
                else {
                    return require("../../../../assets/key/next.png");
                }
            },

            getInfo() {
                if (this.dataInfo && this.dataInfo.aptKeys) {
                    return this.dataInfo.aptKeys;
                }
                else {
                    return [];
                }
            }
        },

        components: {
            KeyItem
        }
    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

    .list-item {
        margin: auto;
        width: 90%;

        header {
            border-radius: 10px;
            margin-top: 14px;
            padding-left: 14px;
            padding-right: 14px;
            justify-content: space-between;
            align-items: center;
            color: white;
            box-sizing: border-box;
            background: $colorDefault;
            height: 44px;
            display: flex;
            img {
                height: 22px;
                width: 22px;
            }
            div {
                align-items: center;
                display: flex;
                img {
                    height: 30px;
                    width: 30px;
                }
            }
        }
    }
</style>
